import type { AcpManagerContext } from './acp-manager-context.js';
import { resolvePromptRunContext } from './resolve-prompt-run-context.js';
import { runAcpPrompt } from './run-acp-prompt.js';
import type { HandlePromptOptions } from './types.js';

export function handlePrompt(ctx: AcpManagerContext, opts: HandlePromptOptions): void {
  const { promptId, sessionId, runId, mode, agentType, agentConfig, sendResult } = opts;

  const runCtx = resolvePromptRunContext(ctx, { runId, mode, agentType, agentConfig, sessionId });
  if (!runCtx) {
    if (runId) {
      sendResult({
        type: 'prompt_result',
        id: promptId,
        ...(sessionId ? { sessionId } : {}),
        runId,
        success: false,
        error: 'No agent type: ensure the app sends agentType on prompts or agent_config for this bridge.',
      });
    }
    return;
  }

  const { activeRunId } = runCtx;

  void runAcpPrompt(ctx, runCtx, opts).finally(() => {
    ctx.promptRouting.unregisterRun(activeRunId);
    ctx.runDispatch.delete(activeRunId);
    ctx.pendingCancelRunIds.delete(activeRunId);
  });
}
